<app-auth-layout>
  <div class="auth-form-content">
      <div class="auth-form-header">
        <h2 class="auth-title">Create an account</h2>
        <p class="auth-subtitle">Join the VB Portal to access and manage your wireless infrastructure all in one place.</p>
      </div>

      @if (errorMessage) {
        <vb-alert type="error" variant="soft" [showIcon]="true" [message]="errorMessage" class="block mb-4" />
      }

      <form [formGroup]="form" (ngSubmit)="signUp()">
        <div class="auth-name-row">
          <div class="auth-field">
            <vb-input
              id="firstName"
              name="firstName"
              type="text"
              label="First Name"
              placeholder="John"
              [required]="true"
              [state]="form.controls.firstName.touched && form.controls.firstName.invalid ? 'error' : 'default'"
              [errorMessage]="form.controls.firstName.touched && form.controls.firstName.invalid ? 'First Name is required' : ''"
              formControlName="firstName"
            />
          </div>
          <div class="auth-field">
            <vb-input
              id="lastName"
              name="lastName"
              type="text"
              label="Last Name"
              placeholder="Doe"
              [required]="true"
              [state]="form.controls.lastName.touched && form.controls.lastName.invalid ? 'error' : 'default'"
              [errorMessage]="form.controls.lastName.touched && form.controls.lastName.invalid ? 'Last Name is required' : ''"
              formControlName="lastName"
            />
          </div>
        </div>

        <div class="auth-field">
          <vb-input
            id="email"
            name="email"
            type="email"
            label="Email Address"
            placeholder="name@company.com"
            [required]="true"
            [state]="form.controls.email.touched && form.controls.email.invalid ? 'error' : 'default'"
            formControlName="email"
          />
        </div>

        <div class="auth-field">
          <vb-input
            id="password"
            name="password"
            type="password"
            label="Password"
            placeholder="Create a password"
            [required]="true"
            helperText="Must be at least 8 characters"
            [state]="form.controls.password.touched && form.controls.password.invalid ? 'error' : 'default'"
            formControlName="password"
          />
        </div>

        <div class="auth-field">
          <vb-input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            label="Confirm Password"
            placeholder="Confirm your password"
            [required]="true"
            [state]="form.controls.confirmPassword.touched && form.controls.confirmPassword.invalid ? 'error' : 'default'"
            formControlName="confirmPassword"
          />
        </div>

        <vb-button
          type="submit"
          variant="primary"
          size="md"
          [fullWidth]="true"
          [loading]="isLoading"
          [disabled]="isLoading">
          @if (isLoading) {
            Creating account...
          } @else {
            Sign Up
          }
        </vb-button>
      </form>

      <div class="auth-divider">
        <span class="auth-divider-line"></span>
        <span class="auth-divider-text">Or sign up with</span>
        <span class="auth-divider-line"></span>
      </div>

      <div class="auth-social-login">
        <vb-button social="apple" type="button" [disabled]="isLoading" (click)="loginWithSocial('apple')" />
        <vb-button social="google" type="button" [disabled]="isLoading" (click)="loginWithSocial('google-oauth2')" />
        <vb-button social="linkedin" type="button" [disabled]="isLoading" (click)="loginWithSocial('linkedin')" />
        <vb-button social="microsoft" type="button" [disabled]="isLoading" (click)="loginWithSocial('Online-Colo-AD')" />
      </div>

      <p class="auth-switch-link">
        Already have an account? <a routerLink="/">Sign in</a>
      </p>

    <div class="auth-footer">
      <div class="auth-footer-links">
        <a routerLink="/terms-of-use">Terms of Use</a>
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a routerLink="/accessibility">Accessibility</a>
      </div>
      <p class="auth-footer-copyright">&copy; {{ currentYear }} Vertical Bridge REIT, LLC. All rights reserved.</p>
    </div>
  </div>
</app-auth-layout>
